// Bank details are stored as text; this checks the format, not account validity.
export function isValidBankAccount(value) {
  if (typeof value !== 'string') return false;
  const trimmed = value.trim();
  return trimmed === '' || (/^[0-9 -]+$/.test(trimmed) && /[0-9]/.test(trimmed));
}

export function isContactDetailComplete(key, data) {
  if (!data?.value) return false;
  if (key === 'bank_account') {
    return isValidBankAccount(data.value) && data.value.trim().length > 0;
  }
  return !!data.verifiedAt;
}
